import {
  Card,
  Text,
  Button,
  Group,
  Stepper,
  Badge,
} from "@mantine/core";
import { IconCopy, IconCheck, IconArrowNarrowRight } from "@tabler/icons";
import { useClipboard } from "@mantine/hooks";
import { useState } from "react"; import { useMediaQuery } from "@mantine/hooks";

export default function Tutorial({ obsId, setOpened }) {
  const clipboard = useClipboard();
  const matches = useMediaQuery("(min-width: 800px)");
  const [active, setActive] = useState(0);
  const nextStep = () =>
    setActive((current) => (current < 3 ? current + 1 : current));
  const prevStep = () =>
    setActive((current) => (current > 0 ? current - 1 : current));

  return (
    <>
        <iframe
      width="853"
      height="480"
      src={`https://www.youtube.com/embed/g7WSwOtblk0`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
      {/* <Stepper
        p="xl"
        m="xl"
        style={{ minHeight: "20rem" }}
        active={active}
        onStepClick={setActive}
        breakpoint="sm"
      >
        <Stepper.Step
          label="Streaming Code"
          description="Setup"
          allowStepSelect={active > 0}
        >
          <div
            style={{
              justifyContent: "center",
              marginTop: 5,
            }}
          >
            <Text size={20} weight={700} p={5}>
              Setup Your Broadcasting Service
            </Text>
            <div style={{ display: matches ? "flex" : "block",alignItems: "center" }}>
              <Text size="14px" p={5} pr={0}>
                Copy your code
              </Text>
              <Button
                variant="subtle"
                rightIcon={
                  clipboard.copied ? (
                    <IconCheck size={20} stroke={1.5} />
                  ) : (
                    <IconCopy size={20} stroke={1.5} />
                  )
                }
                radius="sm"
                size="xs"
                p={3}
                // m="sm"
                styles={{
                  root: { paddingRight: 12, height: 32 },
                  rightIcon: { marginLeft: 5 },
                }}
                onClick={() =>
                  clipboard.copy(
                    `http://d1zgkh7btyfdg4.cloudfront.net/${obsId}`
                  )
                }
              >
                To Clipboard
              </Button>
              <Text size="14px" pl={0} p={5} pr={0}>
                and add the code as a Browser in your broadcasting service.
              </Text>
            </div>
            <Text size={14} p={5}>
              Set the Browser source to full screen, e.g. 1920 x 1080 or 1440 x
              1080.
            </Text>
            <Text size={14} p={5}>
              One code for all your sponsorships, it is personal and shall not
              be shared.
            </Text>
            <div style={{ display: matches ? "flex" : "block",justifyContent: "center" }}>
              <Text m="sm" mt="md" size="lg" weight={500} color="dimmed">
                Get Your Broadcasting Code
              </Text>
            </div>
            <div style={{ display: matches ? "flex" : "block", justifyContent: "center" }}>
              <Button
                variant="light"
                rightIcon={
                  clipboard.copied ? (
                    <IconCheck size={20} stroke={1.5} />
                  ) : (
                    <IconCopy size={20} stroke={1.5} />
                  )
                }
                radius="sm"
                size="sm"
                //   m="sm"
                styles={{
                  root: { paddingRight: 14, height: 38 },
                  rightIcon: { marginLeft: 12 },
                }}
                onClick={() =>
                  clipboard.copy(
                    `http://d1zgkh7btyfdg4.cloudfront.net/${obsId}`
                  )
                }
              >
                Copy Code To Clipboard
              </Button>
            </div>
          </div>
        </Stepper.Step>
        <Stepper.Step
          label="Join Sponsorships"
          description="Select Active Sponsor"
          allowStepSelect={active > 1}
        >
          <Text size={20} weight={700} p={5}>
            Browse & Join Sponsorships
          </Text>
          <Text size="14px" p={5} pr={0}>
            Browse and join paid sponsorships on the Sponsorship page.
          </Text>
          <div style={{ display: matches ? "flex" : "block" }}>
            <Text size="14px" p={5} pr={0}>
              You can join and participate in multiple sponsorships. However,
              you are limited to
            </Text>
            <Text size="14px" weight="bold" p={5} pr={0}>
              one sponsorship per stream.
            </Text>
          </div>
          <div style={{ display: matches ? "flex" : "block", alignItems: "center" }}>
            <Text size="14px" p={5} pr={0}>
              Select the sponsor you want for your next stream by changing the
              status from
              <Badge
                size="xs"
                ml={5}
                mr={5}
                color="red"
                variant="outline"
                p="xs"
              >
                <Text size="10px">Inactive</Text>
              </Badge>
              to
              <Badge size="xs" ml={5} color="green" variant="filled" p="xs">
                <Text size="10px">Active</Text>
              </Badge>
            </Text>
          </div>
        </Stepper.Step>
        <Stepper.Step
          label="Go Live"
          description="Upload VOD"
          allowStepSelect={active > 2}
        >
          <Text size={20} weight={700} p={5}>
            Go Live & Upload VOD
          </Text>
          <Text size="14px" p={5} pr={0}>
            Once you've added the code to your broadcasting service, joined a
            campaign and made it active you can start your broadcast.
          </Text>
          <div style={{ display: matches ? "flex" : "block", alignItems: "center" }}>
            <Text size="14px" p={5} pr={0}>
              After the sponsored stream you need to
            </Text>
            <Text size="14px" weight="bold" p={5} pr={0}>
              submit the URL of your broadcast
            </Text>
            <Text>, see</Text>
            <Badge
              size="xs"
              ml={5}
              color="blue"
              radius={5}
              variant="outline"
              p="xs"
            >
              <Text size="10px">Add VOD</Text>
            </Badge>
          </div>
          <Text size="14px" p={5} pr={0}>
            Once the VOD is submitted, the broadcast will be reviewed by Adly's
            campaign team.
          </Text>
        </Stepper.Step>
        <Stepper.Completed>
        <Text size={20} weight={700} p={5}>
            Important - Billings Data
          </Text>
          <Text size="14px" p={5} pr={0}>
          To recieve payment you need to submit billing data, see Settings {"->"} Billing Data.
          </Text>
          
        </Stepper.Completed>
      </Stepper>
      <Group position="center" m="xl">
        {active != 0 ? (
          <Button variant="default" onClick={prevStep}>
            Back
          </Button>
        ) : (
          ""
        )}

        {active < 3 ? <Button onClick={nextStep}>Next step</Button> : ""}
      </Group> */}
    </>
  );
}
